module.exports = __webpack_public_path__ + "img/bank_transfer_logo.d690b81e.png";